import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { Event } from 'api/general/models';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Event>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const contextualEventsReducer = createReducer<State, Actions>(initialState, {
  [actions.getContextualEvents.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getContextualEvents.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getContextualEvents.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getContextualEvents.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
  [actions.toggleFavoriteEvent.success.type]: (draft, action) => {
    const event: any = draft.byId[action.payload.id];
    if (event) event.user_favorite = !event.user_favorite;
  },
});

export default contextualEventsReducer;
